import React from "react";
import { Button } from "../../ui";

type UploadType = "BANK_STATEMENT" | "CIBIL_REPORT";

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id: string;
  type?: UploadType;
};

const ACCEPT_MAP: Record<string, string> = {
  BANK_STATEMENT: "application/pdf",
  DEFAULT: "image/*,application/pdf",
};

const ButtonFileUploader: React.FC<Props> = ({ onChange, id, type }) => {
  const openFileDialog = () => {
    document.getElementById(id)?.click();
  };

  return (
    <div className="text-center">
      <input
        type="file"
        id={id}
        multiple
        className="hidden"
        accept={ACCEPT_MAP[type || "DEFAULT"]}
        onChange={(event) => {
          onChange(event);
          event.target.value = "";
        }}
      />

      <Button onClick={openFileDialog} variant="outlined-primary">
        + Upload
      </Button>
    </div>
  );
};

export default ButtonFileUploader;
